import type { FaireProductEntity } from "../../entity_types/product";

export const p_8ecfjessqr: FaireProductEntity = {
  token: "p_8ecfjessqr",
  type: "product",
  name: "14K Gold Diamond Eternity Ring, Wedding Band, Stackable Ring",
  brandToken: "b_tk6ffkngnw",
  brandName: "PureYou Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/f4422cc7d1b608de11be07ac97b05030eaae9cf52cc748fd7f4c3ffa9ce5951b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a2c4840ab35e3d14640009a2f73bbb8bc94c472c65c949d97ade251d6c67c31.png",
    "https://cdn.faire.com/fastly/facf614aa347b740d7282df497095528b69a78013915cf455e7fdcb4ee380d59.png",
    "https://cdn.faire.com/fastly/676644ba148fea8d9a37fe95d8d3e447523e6ba8551f905ae592213ffe921bc2.png",
    "https://cdn.faire.com/fastly/8ef742e5b821b93293ab2e6002f675aedf36d48f73ae07c0e41b736a6a17543f.png",
    "https://cdn.faire.com/fastly/e676ae635db378bec6a37240d4ba5cb9f1fd0189c19082315c6e0b13f96f5d1b.png",
    "https://cdn.faire.com/fastly/38568ff020029ad6dc10241f3790c151af3451c0a67a2678414d122241e98afa.png",
    "https://cdn.faire.com/fastly/83d02a27aaeed63da5afd36ee953b81b46738cfcfac0af4b3a224eab36e79f7f.png",
    "https://cdn.faire.com/fastly/07649b78197d2ced93860b560e751c2018eb070ce4120b33128df1d1b7ac9cf5.png",
    "https://cdn.faire.com/fastly/a912af98db08ae76437809a95ac3243cd2e9b45342b4162891b188305a73799d.png",
    "https://cdn.faire.com/fastly/978db5186f42ac6880a1941bce5f55b467f77872e92a4787207dfb739af99760.png",
    "https://cdn.faire.com/fastly/87462cfd1acdb5ef57da71956620c635de0b6656a44e7f7621da7eff95bdabca.png",
  ],
  priceDollars: 2312.71,
  description:
    '"Artfully crafted golden strands intertwine to form this stunning ring, punctuated by sparkling diamonds. The fluid, woven design evokes a sense of endless connection and harmony. A masterpiece that embodies both strength and delicacy, perfect for the modern, sophisticated wearer."\n\nDiamond Details:\nGemstone :Lab Grown Diamond\nStone Shape: Round\nDiamond Carat Weight: 0.700ctw\n10x 0.07ct Round\nWidth: 8mm\nColor: D-F\nCut: Excellent\nClarity: VS/VVS\n\nMetal Details :\nMetal Option: 14k, 18k Stamped Solid Gold \nAvailable in: Yellow Gold, White Gold, Rose Gold\n\nRing Sizes range from 3-12 US. If you have any questions about sizing, please do not hesitate to reach out!\n\nAt PureYou, we are dedicated to excellent service and top-quality jewelry. Our lab-grown diamonds, with the same properties as natural ones, are IGI-certified and crafted by experts. We offer custom designs, fair pricing, no MOQ, no middlemen, and uphold ethical practices. All pieces are hypoallergenic, nickel-free, handcrafted, and made to order, with full customization available. Also offered in natural diamonds—message us anytime, we’re happy to help!',
  tags: [],
  msrpDollars: 4625.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:44:43.256Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
